import Navigation from '../../components/utils/Navigation';
import NoDataAvailable from '../../components/utils/NoDataAvailable.vue';
import TeamDialog from '../../components/dialogs/ticketing/TeamDialog.vue';
import { deleteTeam } from '../../utils/entityMethods/team';

function emptyTeam() {
    return {
        id: null,
        name: "",
        description: "",
        is_active: true,
        members: [],
        groups: []
    };
}

export default {
    name: "Teams",
    components: { Navigation, NoDataAvailable, TeamDialog },
    data() {
        return {
            teams: null,
            search: "",
            allUsers: null,
            teamID_lead: {}
        };
    },
    computed: {
        isAdmin() {
            return this.$root.authObj && this.$root.authObj.roles == 'Admin';
        },
        filteredTeams() {
            if (!this.teams) return [];
            const q = (this.search || "").trim().toLowerCase();
            if (!q) return this.teams;
            return this.teams.filter(t => (t.name || "").toLowerCase().includes(q));
        }
    },
    async mounted() {
        if (!this.$root.checkAuth()) return;
        this.$session.setRoomPC(null);
        if (this.$root.socket) this.$root.socket("SETPC", null);
        this.allUsers = this.$session.getUsers();

        this.$root.$on("refreshTeams", this.getTeams);

        this.getTeams();
    },
    methods: {
        async getTeams() {
            const res = await this.$api.getTeams();

            if (this.teams == null) {
                this.teams = res;
            }
            else {
                this.teams.update(res);
            }
            var lead;
            this.teams.forEach(t => {
                lead = (t.users || []).find(m => m.is_lead);
                if (lead) {
                    this.teamID_lead[t.id] = this.allUsers.find(u => u.id == lead.id_user);
                }

            });
        },

        normalizeTeam(t) {
            // Modello v2: team_groups (solo gruppi, niente più id_remote/PC singoli)
            var rawGroups = Array.isArray(t.groups)
                ? t.groups
                : (Array.isArray(t.host_assignments) ? t.host_assignments : []); // fallback per backend legacy
            return {
                id: t.id,
                name: t.name || "",
                description: t.description || "",
                is_active: t.is_active === false ? false : true,
                members: Array.isArray(t.members) ? t.members.map(m => ({
                    id_user: m.id_user || m.id,
                    username: m.username,
                    is_lead: !!m.is_lead
                })) : [],
                groups: rawGroups
                    .map(g => ({
                        id_group: g.id_group || g.id || null,
                        name: g.name || g.group_name || null
                    }))
                    .filter(g => g.id_group != null)
            };
        },

        groupCount(team) {
            if (Array.isArray(team.groups)) return team.groups.length;
            return team.groups_count || 0;
        },


        deleteTeam
    }
};
